'use strict';

/**
 * operateCenterModule
 *
 * Description 运营中心
 * Aurthor:SMG 2016-4-19
 */

angular.module('operateCenterModule', ['operpateCenterRouterModule']).controller('operateCenterCtrl', [
    '$q',
    '$scope',
    '$location',
    'trsHttpService',
    'publicToolService',
    function ($q, $scope, $location, trsHttpService, publicToolService) {
        // initStatus();
        // initData();

        // /**
        //  * [initStatus description] 初始化状态
        //  * @return {[type]} [description]
        //  */
        // function initStatus() {
        //     $scope.status = {};
        //     $scope.data = {
        //         listInfo: [],
        //         grouplist: [],
        //         token: '',
        //         remarkUrl: $location.$$absUrl.indexOf('localhost') > -1 ? '/#/newspaperRemark/toolbar' : '/xjmediaCloud/#/newspaperRemark/toolbar',
        //         xjBigScreenUrl: window.location.origin + '/xjshowscreen/#/hotNews',
        //         xjCountryScreen: window.location.origin + '/xjcountryscreen/#/home?tenantid=' + JSON.parse(sessionStorage.getItem('ls.curUserInfo')).TENANTID,
        //         copyrightSystem: window.location.origin + '/CopyRightSystem',
        //         xjmsgexchangeplt: window.location.origin + '/xjmsgexchangeplt/#/Index',
        //         statistic: window.location.origin + '/statistic',
        //         // 在线商城的url
        //         onlineShopUrl: 'http://172.16.21.31/api/ids/index.php',
        //         // 全疆发稿统计的url
        //         publishDocUrl: window.location.origin + '/toolkit/#/distributionStatistics',
        //         // 易企秀的信息
        //         eqixiu: {
        //             url: '',
        //             unique: 'tools',
        //             canEnter: false,
        //             imgUrl: './images/operation_h5_icon.png',
        //             title: 'H5工具',
        //             content: '支持图片、视频、音乐等不同元素的添加，支持动画效果的添加和预览，降低制作门槛，做到可视化新闻作品的所见即所得。',
        //             isShow: true,
        //         },
        //         moduleRightsName: {
        //             '智能工具': 'intelligent',
        //             '传播分析': 'analysis',
        //             '通讯员平台': 'correspondent',
        //             '移动通': 'mobilecommunicate',
        //             '客户端运营': 'appoperation',
        //             '评报系统': 'dbpb',
        //             '直播系统': 'live',
        //             '石榴学院': 'school',
        //             'H5工具': 'tools',
        //             '网脉': 'stockwork',
        //             '版权系统': 'copyright',
        //             '全疆信息交换平台': 'infoexchange',
        //             '统计分析子系统': 'statistical',
        //             '新疆日报大屏': 'bigscreen',
        //             '在线商城': 'onlineshop',
        //             '全疆发稿统计': 'publishdoc',
        //         },
        //         moduleRights: [],
        //     };
        //     publicToolService.queryModeconfiguration('operationCenter');
        // }

        // /**
        //  * [initData description] 初始化数据
        //  *
        //  * @return  {[type]}  [return description]
        //  */
        // function initData() {
        //     publicToolService.queryModeconfiguration('operationCenter').then((token) => {
        //         $scope.cloudViewUrl = 'http://cloud.xjyntv.cn/login/xjrb/v1/third/authentication?token=' + token;
        //         // 拼接直播的入口url
        //         $scope.LiveUrl = 'https://ys-web.xjmty.com//login/xjrb/v1/third/authentication?token=' + token;
        //         getModalRights().then((data) => {
        //             if (data.length) {
        //                 $scope.data.moduleRights = data;
        //             }
        //             getProdInfo();
        //         }, () => {
        //             getProdInfo();
        //         });
        //     });
        //     calcBodyHeight();
        // }

        // /**
        //  * [getProdInfo description] 获取产品信息
        //  * @return {[type]} [description]
        //  */
        // function getProdInfo() {
        //     var listInfo = [
        //         // { url: "https://mujing.tmuyun.com//#/login", canEnter: false, imgUrl: './images/operation_mujing_icon.png', title: '用户行为分析', content: '强大的数据支撑功能，通过产品概况，实时数据以及转化、用户、访问、内容、渠道、地域、线路等众多维度分析，实时掌控媒体线上产品的运营情况，让媒体迈向' },
        //         // {
        //         //     url: '/toolkit',
        //         //     unique: 'intelligent',
        //         //     canEnter: true,
        //         //     imgUrl: './images/operation_smarttools_icon.png',
        //         //     title: '智能工具',
        //         //     content: '为宣传管理工作和媒体生产工作提供核心系统支撑，同时建设大数据、云计算、人工智能等能力，集成内容生产、智能支撑、办公协作等多种实用工具，打造先进生产体系，实现高效系统运营管理。',
        //         //     isShow: true
        //         // },
        //         {
        //             url: '/spread',
        //             unique: 'analysis',
        //             canEnter: true,
        //             imgUrl: './images/operation_mushu_icon.png',
        //             title: '传播分析',
        //             content:
        //                 '采用稿件数量、稿件标签、稿件自有平台传播互动情况、稿件互联网转载传播情况、稿件舆论环境等聚合的传播评价模式，多层次、全形态的为采编人员提供内容传播分析的一站式数据报表统计平台。',
        //             isShow: true,
        //         },
        //         {
        //             url: '/mcnadmin/web/user/ids.do',
        //             unique: 'correspondent',
        //             canEnter: true,
        //             imgUrl: './images/operation_muhao_icon_1.png',
        //             title: '通讯员平台',
        //             content:
        //                 '为外部内容创作者保驾护航的内容开放平台，整合大数据分析能力，外部通讯员和媒体之间可以通过线上实现快速签约和身份认证审核，一键分发，覆盖多个内容渠道。',
        //             isShow: true,
        //         },
        //         {
        //             url: 'http://172.16.21.61:8082/xj/index/index',
        //             unique: 'appoperation',
        //             canEnter: true,
        //             imgUrl: './images/operation_meitiyun_icon.png',
        //             title: '客户端运营',
        //             content:
        //                 '实现客户端运营功能，可对客户端的非新闻类业务进行管理，主要包括活动运营、广告管理、直播管理、评论管理、石榴号运营等。',
        //             isShow: true,
        //         },
        //         // 运营活动的评报系统入口
        //         {
        //             url: $scope.data.remarkUrl,
        //             unique: 'dbpb',
        //             canEnter: true,
        //             imgUrl: './images/operation_newspaperRemark_icon.png',
        //             title: '评报系统',
        //             content: '实现对报社数字报刊在线点评的功能；主要包括版面稿件的评级、评语等功能，全程可视化操作，点评的等级和评语均可在系统内实时查看；评报行为全流程跟踪，保证评报数据安全可靠。',
        //             isShow: true,
        //         },
        //         // 运营中心的直播入口
        //         {
        //             url: $scope.LiveUrl,
        //             unique: 'live',
        //             canEnter: true,
        //             imgUrl: './images/operation_live_icon.png',
        //             title: '直播系统',
        //             content: '拥有广播级视音频核心技术，提供多终端、高画质、低延时的直播服务，搭配云导播、云收录及流拆条等功能丰富的直播处理工具，适用于不同行业不同类型多场景的应用需求，让视频应用更轻松。',
        //             isShow: true,
        //         },
        //         // 运营中心的培训子系统入口
        //         {
        //             url: '/pub/slyxy',
        //             unique: 'school',
        //             canEnter: true,
        //             imgUrl: './images/operation_slyxy_icon.png',
        //             title: '石榴学院',
        //             content: '提供在线学习、在线考试、在线答疑等方式相结合的技术和应用培训服务，辅助媒体中心业务人员快速利用平台进行内容生产，媒体中心系统管理人员及运维人员保障平台的正常运转。',
        //             isShow: true,
        //         },
        //         // 运营中心的易企秀入口
        //         // $scope.data.eqixiu,
        //         // 大屏入口
        //         // {
        //         //     url: $scope.data.permissionData.gonggaoproduct ? $scope.data.xjCountryScreen : $scope.data.xjBigScreenUrl, 
        //         //     canEnter: true,
        //         //     imgUrl: './images/operation_big_screen_icon.png',
        //         //     title: $scope.data.permissionData.gonggaoproduct ? '大数据服务中心' : '新疆日报大屏',
        //         //     content: '可视化展现媒体中心建设成果,实时跟踪本地及全疆、全网的舆情热点变化',
        //         //     isShow: true
        //         // },
        //         // 网脉
        //         {
        //             // url: 'https://ta.xjmty.com',
        //             url: publicToolService.getModeconfigurationDirect('wmConfig', 'operationCenter').url,
        //             // url: '../wm.html',
        //             unique: 'stockwork',
        //             canEnter: true,
        //             imgUrl: './images/operation_wangmai_icon.png',
        //             title: '网脉',
        //             content: '强大的数据支撑功能，通过产品概况，实时数据以及转化、用户、访问、内容、渠道、地域、线路等众多维度分析，实时掌控媒体线上产品的运营情况。',
        //             isShow: true,
        //         },
        //         // 版权系统
        //         // {
        //         //     url: $scope.data.copyrightSystem,
        //         //     unique: 'copyright',
        //         //     canEnter: true,
        //         //     imgUrl: './images/operation_bqxt_icon.png',
        //         //     title: '版权系统',
        //         //     content: '对原创作品在发布推广前确权后的全网监测、取证，为知识产权的保护提供维权依据。实现对集团内新闻作品的版权追踪、预警、维权保护，同时提供针对自身新闻产品的定制化版权维护服务，实现版权确权、维权取证等维权措施，实现营收。',
        //         //     isShow: true,
        //         // },
        //         // 全疆系统
        //         // {
        //         //     url: $scope.data.xjmsgexchangeplt,
        //         //     unique: 'infoexchange',
        //         //     canEnter: true,
        //         //     imgUrl: './images/operation_quanjiang_icon.png',
        //         //     title: '全疆信息交换平台',
        //         //     content: '实现全疆成品资源、素材互通互享在线交易的平台，能直观体现全疆融媒体平台的建设情况。平台包含“专题、资讯、图片、视频、直播”五大类型的资源，各区县融媒体中心用户可一键取稿使用。各融媒体中心的建设情况可在“榜单”模块提现，系统从多个维度呈现融媒体平台的建设成果。',
        //         //     isShow: true,
        //         // },
        //         // 统计分析
        //         {
        //             url: $scope.data.statistic,
        //             unique: 'statistical',
        //             canEnter: true,
        //             imgUrl: './images/operation_tongjifenxi_icon.png',
        //             title: '统计分析子系统',
        //             content: '解决个人作者、组织管理者的数据需求，对作者及团队生产成果数据进行展示和导出工作，并为组织管理者、个人作者提供内容数据、行为数据及传播情况。',
        //             isShow: true,
        //         },
        //         // 在线商城
        //         // {
        //         //     url: $scope.data.onlineShopUrl,
        //         //     unique: 'onlineshop',
        //         //     canEnter: true,
        //         //     imgUrl: './images/operation_shop_icon.png',
        //         //     title: '在线商城',
        //         //     content: '支持商户入驻的多用户商城系统，提供商户入驻管理、店铺管理、商品管理、订单管理、会员管理、财务结算、销售统计等核心功能，帮助企业低成本快速构建在线商城。',
        //         //     isShow: true,
        //         // },
        //         // 全疆发稿统计
        //         {
        //             url: $scope.data.publishDocUrl,
        //             unique: 'publishdoc',
        //             canEnter: true,
        //             imgUrl: './images/operation_documentNum_icon.png',
        //             title: '全疆发稿统计',
        //             content: '基于强大的数据支撑，汇集全疆各融媒体中心的发稿数据统计，为组织管理者提供全疆融媒体建设情况概览。',
        //             isShow: true,
        //         },
        //         {
        //             url: $scope.data.xjBigScreenUrl,
        //             unique: 'bigscreen',
        //             canEnter: true,
        //             imgUrl: './images/operation_big_screen_icon.png',
        //             title: '新疆日报大屏',
        //             content: '可视化展现媒体中心建设成果,实时跟踪本地及全疆、全网的舆情热点变化',
        //             isShow: true
        //         },
        //         // {
        //         //     url: $scope.cloudViewUrl,
        //         //     canEnter: true,
        //         //     imgUrl: './images/operation_cloudView.png',
        //         //     title: '视频云',
        //         //     content:
        //         //         '利用专业的视音频实时处理技术，结合人脸识别、场景识别等AI智能能力，满足感知增强、资源节省的应用需求，提供了云直播、云导播、云转码、云拆条、智能拆条等专业工具，实现了大并发、高互动、顺畅使用的云端工具体验',
        //         // },
        //         // { canEnter: false, imgUrl: './images/operation_mujian_icon.png', title: '版权检测', content: '全网内容侵权监测、白名单灵活配置、确权便捷准确、数据报表分析。' },
        //         // { url: "/mrs/", canEnter: true, imgUrl: './images/operation_mutong_icon.png', title: '稿费管理', content: '灵活的稿件评级机制，同时支持自动、手动双模式，迅速计算稿费；灵活的稿费审核机制，具备邮寄、银联、支付宝等多种稿费发放模式。' },
        //         // { url: "/wcm/checkRight.do?MethodName=checkLoginRedirect", canEnter: true, imgUrl: './images/operation_muyi_icon.png', title: '绩效考核', content: '近百项数据纬度，灵活组合定义考核指标，每个媒体都可以快速配置出自己的考核系统。' },
        //         // { url: "/LargeScreenAssembly/", canEnter: false, imgUrl: './images/operation_zhihuijiance_icon.png', title: '指挥监测', content: '灵活配置指挥监测中心所需要的舆情、线索、成品、任务等各种指挥调度场景,实现跟踪全网舆情变化,提高采编执行效率,了解互联网用户反馈和统筹调度采编资源的目的。' },
        //     ];
        //     listInfo = listInfo.filter((item) => $scope.data.moduleRights.indexOf($scope.data.moduleRightsName[item.title]) >= 0);
        //     if ($scope.data.moduleRights.indexOf('gonggaoproduct') >= 0) { // 这表示不是新疆日报用户 不显示新疆日报大屏和全疆发稿统计 
        //         listInfo = listInfo.filter((item) => item.unique !== 'publishdoc' && item.unique !== 'bigscreen');
        //     }

        //     var grouplist = [];
        //     for (var j = 0; j < Math.ceil(listInfo.length / 4); j++) {
        //         grouplist[j] = [];
        //         for (var i = 0; i < listInfo.length; i++) {
        //             if (i < 4 * (j + 1) && i >= 4 * j) {
        //                 grouplist[j].push(listInfo[i]);
        //             }
        //         }
        //     }
        //     $scope.data.grouplist = grouplist;
        //     // if ($scope.data.moduleRights.indexOf('gonggaoproduct') >= 0) { // 这表示不是新疆日报用户 不显示新疆日报大屏
        //     //     $scope.data.grouplist[$scope.data.grouplist.length - 1].pop();
        //     // }
        // }

        // /**
        //  * [getH5ToolInfo description]获取H5工具 易企秀的信息
        //  * @return  {[type]}  [return description]
        //  */
        // // function getH5ToolInfo() {
        // //     let params = {
        // //         serviceid: 'mlf_eqxiuaccount',
        // //         methodname: 'queryH5EditorUrlByTenantId',
        // //         TenantId: $scope.data.token.tenantId
        // //     };
        // //     trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'POST').then(function (result) {
        // //         if (result.TYPE === '3') {
        // //             $scope.data.eqixiu.url = result.DETAIL;
        // //             $scope.data.eqixiu.canEnter = true;
        // //         } else {
        // //             $scope.data.eqixiu.canEnter = false;
        // //         }
        // //     });
        // // }

        // /**
        //  * [calcBodyHeight description] 计算body的高度 不出滚动条
        //  * @return {[type]} [description]
        //  */
        // function calcBodyHeight() {
        //     $('.operate_body').css({ overflowY: 'auto' });
        //     $('body').css({ overflow: 'hidden' });
        //     window.onresize = function () {
        //         var htmlHei = $('html').height();
        //         $('.operate_body').height(htmlHei - 60);
        //     };
        // }

        // /**
        //  * [enterProduct description] 进入产品
        //  * @param  {[type]} item [description] 产品信息
        //  * @return {[type]}      [description]
        //  */
        // $scope.enterProduct = function (item) {
        //     window.open(item.url);
        // };

        // /**
        //  * [getModalRights description] 获取权限数据
        //  * @return {[type]} [description]
        //  */
        // function getModalRights() {
        //     let deffer = $q.defer();
        //     let params = {
        //         serviceid: 'mlf_metadataright',
        //         methodname: 'queryOperTypesByOperationModal',
        //         Classify: 'operationcenter',
        //     };
        //     $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
        //         // console.log(data);
        //         deffer.resolve(data);
        //     });
        //     return deffer.promise;
        // }
    },
]);
